module.exports = __webpack_public_path__ + "img/DK24260453.af990384.png";